// Angular
import { AfterViewInit, Component, ElementRef, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Ionic
import {
  AlertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

// Local library
import { AuthFacade } from '@amwager/authentication/data-access';
import { SessionService } from '@amwager/data-access';
import { StatementsComponent } from '../statements/statements.component';
import {
  WageringPreferencesComponent
} from '../settings/wagering-preferences/wagering-preferences.component';
import {
  FavoriteTracksComponent
} from '../settings/favorite-tracks/favorite-tracks.component';
import {
  WageringLimitsComponent
} from '../settings/wagering-limits/wagering-limits.component';

// Third party
import * as _ from 'lodash';

@Component({
  selector: 'feature-ion-amwager3-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonInput,
    IonIcon,
    CommonModule,
    FormsModule,
    StatementsComponent,
    WageringPreferencesComponent,
    FavoriteTracksComponent,
    WageringLimitsComponent
  ],
  standalone: true
})
export class AccountSettingsComponent implements OnInit, AfterViewInit {

  cardContentHTMList!: HTMLElement[];

  controller = {
    wageringPreferences: false,
    favoriteTracks: false,
    videoOptions: false,
    language: false,
    wageringLimits: false,
    changePassword: false
  };

  private showAlertInfoHandler?: HTMLIonAlertElement;

  constructor(
    private modalCtrl: ModalController,
    private elementRef: ElementRef,
    private readonly sessionService: SessionService,
    private readonly authFacade: AuthFacade,
    private readonly alertCtrl: AlertController,
    private readonly ngZone: NgZone
  ) {
    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.alertCtrl?.dismiss();
        this.showAlertInfoHandler?.dismiss();
      }
    });
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    // update branch
  }

  ngAfterViewInit() {

    // hide card-content
    this.cardContentHTMList = this.elementRef.nativeElement.querySelectorAll(
      '.my-settings-section .card-content'
    );
    _.forEach(this.cardContentHTMList, (html: HTMLElement) => {
      html.classList.add('card-hide');
    });
  }

  selectCard(method: string): void {

    const settingsSection = this.elementRef.nativeElement.querySelector(
      '.my-settings-section'
    );


    const showCard = this.elementRef.nativeElement.querySelector(
      '.my-settings-section .' + method + '.card-content'
    );
    const settingsRow = this.elementRef.nativeElement.querySelectorAll(
      '.my-settings-section .settings-row'
    );


    const openChev = this.elementRef.nativeElement.querySelector(
      '.my-settings-section .' + method + '.settings-row .open-chev'
    );
    const closeChev = this.elementRef.nativeElement.querySelector(
      '.my-settings-section .' + method + '.settings-row .close-chev'
    );

    // open arrow
    if (closeChev.classList.contains('active-chev')) {
      settingsSection.classList.add('active');
      closeChev.classList.remove('active-chev');
      openChev.classList.add('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (cardContent: HTMLElement) => {
        cardContent.classList.add('card-hide');
      });

      // show showCard
      showCard.classList.remove('card-hide');

      settingsRow.forEach((row: HTMLElement) => {
        row.classList.add('card-hide');

        if (row.dataset['name'] === showCard.dataset['name']) {
          row.classList.remove('card-hide');
        }
      });

      (this.controller as any)[method] = true;

    }
    // close arrow
    else {
      settingsSection.classList.remove('active');
      closeChev.classList.add('active-chev');
      openChev.classList.remove('active-chev');

      // hide all
      _.forEach(this.cardContentHTMList, (html: HTMLElement) => {
        html.classList.add('card-hide');
      });

      // show all
      settingsRow.forEach((row: HTMLElement) => {
        row.classList.remove('card-hide');
      });

      (this.controller as any)[method] = false;
    }

  }

  async openLanguage() {
    this.showAlertInfo('The countdown to your next big win starts soon!');
  }

  async showAlertInfo(msg: string): Promise<void> {
    this.showAlertInfoHandler = await this.alertCtrl.create({
      header: 'Info',
      message: msg,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            // comment out for now
            // this.ngZone.run(()=>{
            //   this.modalCtrl.dismiss();
            // });
          }
        }
      ]
    });

    await this.showAlertInfoHandler.present();
  }

  async changePasswordPrompt(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Account Change Password. Confirm',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Change Password',
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
              this.authFacade.logout('change-password');
            });
          }
        }
      ]
    });

    await alert.present();
  }

  cancel(): void {
    this.modalCtrl.dismiss();
  }

  close(): void {
    this.modalCtrl.dismiss();
  }

}
